const PLACEHOLDER_CLIENT_KEYS = new Set(["xxxx", "your_client_key_here"]);

/**
 * The attribute experiments hash on: the first-party visitor id, under a literal dotted key in
 * the GrowthBook org's attribute schema (not a nested path). An experiment whose hash attribute
 * is missing is skipped without an error, serving control to everyone and reporting no exposures.
 */
export const VISITOR_ID_ATTRIBUTE = "visitor.id";

export function resolveGrowthBookClientKey(): string | null {
  const clientKey = process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY?.trim();

  if (!clientKey) {
    return null;
  }

  if (PLACEHOLDER_CLIENT_KEYS.has(clientKey)) {
    return null;
  }

  return clientKey;
}
